module.exports = __webpack_public_path__ + "static/media/blackoutDay_home_mobile.b0dca798.jpg";